<template>
  <div
    class="form-colorpicker"
    v-bind:class="{
      'has-error': error,
      'small-input': smallInput,
    }"
  >
    <FormLabel v-if="label" class="form-colorpicker__label" :is-required="isRequired">{{ label }}</FormLabel>
    <VColorPicker mode="hexa" hide-mode-switch v-model="color"></VColorPicker>
    <span v-if="hint" class="form-colorpicker__hint">{{ hint }}</span>
    <span v-if="error && !smallErrorMessage" class="form-colorpicker__error-msg">{{ error }}</span>
    <span
      v-if="error && smallErrorMessage"
      class="form-colorpicker__small-error-msg"
      v-tooltip="{ content: error, classes: 'error' }"
    >
      <BaseIcon name="alert-circle" class="form-colorpicker__error-icon" />
    </span>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon.vue';
import FormLabel from '@/components/form/FormLabel';

export default {
  name: 'FormColorPicker',
  components: {
    BaseIcon,
    FormLabel,
  },
  $_veeValidate: {
    value() {
      return this.value;
    },
  },
  props: {
    value: {
      type: String,
      default: '#000000',
    },
    label: {
      type: String,
      required: false,
    },
    hint: {
      type: String,
      required: false,
      default: '',
    },
    error: {
      type: String,
      required: false,
      default: null,
    },
    isRequired: Boolean,
    hasGrayBackground: {
      type: Boolean,
      default: false,
      required: false,
    },
    smallErrorMessage: Boolean,
    smallInput: Boolean,
  },
  data() {
    return {
      color: this.value,
    };
  },
  computed: {
    attrs() {
      const { rows, ...attrs } = this.$attrs;
      return attrs;
    },
  },
  watch: {
    value() {
      this.color = this.value;
    },
    color() {
      this.$emit('input', this.color);
    },
  },
};
</script>

<style lang="scss">
.form-colorpicker {
  padding: 24px 0;
  width: 100%;

  &__label {
  }

  &__hint {
    bottom: 0;
    color: $color-neutral;
    font-size: 12px;
    left: 0;
    position: absolute;
  }

  &__error-msg {
    bottom: 0;
    color: $color-error;
    font-size: 12px;
    font-style: italic;
    position: absolute;
    right: 0;
  }

  &__small-error-msg {
    bottom: 37px;
    color: $color-error;
    display: flex;
    height: 16px;
    position: absolute;
    right: -20px;
    width: 16px;
  }

  &__error-icon {
    height: 16px;
    width: 16px;
  }

  /* MODIFIERS */
  &.small-input {
    .form-colorpicker__small-error-msg {
      left: 86px;
      right: unset;
    }
  }
}
</style>
